import _ from 'lodash';
import sanitizeHtml from 'sanitize-html';

export function getTextFromHtml(html: string): string {
  return sanitizeHtml(html, {
    allowedTags: [],
    allowedAttributes: {},
  }).trim();
}

export function getDecodedTextFromHtml(html: string): string {
  return _.unescape(getTextFromHtml(html));
}

export function removeTags(input: string): string {
  return input ? input.replace(/(<([^>]+)>)/ig, '') : '';
}

export function trimText(input: string): string {
  if (input.length > 80) {
    return `${input.substr(0, 0)}  ... ${input.substr(input.length - 15, input.length)}`;
  }

  return input;
}

export function cleanUpHtml(html: string): string {
  return sanitizeHtml(html, {
    allowedTags: ['b', 'i', 'em', 'strong', 'a', 'u', 'sup', 'sub', 'strike', 's'],
    allowedAttributes: { a: ['href', 'target', 'title'] },
    transformTags: {
      i: 'em',
    },
  });
}

export function cleanUpText(text: string): string {
  return sanitizeHtml(text, {
    allowedTags: [],
    disallowedTagsMode: 'recursiveEscape',
  });
}
